import { Button } from "@chakra-ui/react";
import { PlusIcon } from "lib/icons/plusIcon";
import { useSuperPacks, useToastNotification } from "lib/hooks";
import { FC } from "react";
import { useSuperpacksContext } from "lib/context";
import { superPacksClient } from "lib/clients";

export const CreateSuperpackButton:FC<{ parent?: string }> = ({ parent }) => {
  const { errorToast } = useToastNotification();
  const { setEditingSuperpackId } = useSuperpacksContext();
  const { mutate, data } = useSuperPacks();

  const create = async (): Promise<void> => {
    try {
      let newSuperpack = {
        count: 0,
        name: 'Untitled Superpack',
        parent_id: parent,
        id: null,
      };

      const { data: { id } } = await superPacksClient.createSuperPack({ name: newSuperpack.name, parent_id: parent });
      setEditingSuperpackId(id);
      newSuperpack.id = id;

      await mutate([ ...data, newSuperpack], false);
    } catch (e) {
      errorToast({ title: 'Error', description :'Could not create new pack' });
    }
  }

  return (
    <Button size={"sm"} onClick={create} leftIcon={<PlusIcon boxSize={"12px"} />} variant="light">
      {parent ? 'Add' : 'Create'} a new superpack
    </Button>
  )
}
